<template>
	<div class="row">
		<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-if="user">
			<div class="membership-card">
				<div class="membership-top">
					<h2>{{ locale.text_membership_card_title }}</h2>
				</div>
				<div class="membership-bottom">

					<b>{{ full_name }}</b>
					<br /><b>{{ locale.text_membership_number_prefix + ' ' + $root.auth.user_id }}</b>

					<span>{{ locale.text_membership_card_children_title }}</span>
					<ul>
					<li v-for="participant in participants">{{ [participant.first_name, participant.last_name].join(' ') }}</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {

	data () {
		return {
			participants: [],

			user: null,
		}
	},
	computed: {
		full_name: function () {
			if(this.user)
				return [this.user.first_name, this.user.last_name].join(' ');
		},
		locale: function () {
		    return this.$root.locale.account.membership;
		}
	},
    created () {
        /**Checking if the user is currently logged in**/
        axios.get('/camp-booking/users/current')
            .then(response => {
                if(response.data.data.user_id == null) {
                    this.$router.push({name: 'auth.login'});
                    return false;
                }
            })

    	/**
    		Getting the users details
    	**/
    	axios.get('/camp-booking/users/'+this.$root.auth.user_id)
    		.then(response => {
    			this.user = response.data.data
    		})
    	/**
			Getting the children for the user
    	**/
    	axios.get('/camp-booking/participants')
    		.then(response => {
    			this.participants = response.data.data
    		})

        /**
         * Setting the headers
         */
        this.$root.headers = {
            navigate: {
                name: 'account.overview'
            },
            title: this.$root.locale.miscellaneous.page_headings.account.view_membership
        }
	}
}
</script>



// WEBPACK FOOTER //
// Membership.vue?a2d0c8a4